module.exports = __webpack_public_path__ + "static/media/WhitetailDeer.svg";